// Get the auth token from localStorage
export const getAuthToken = () => {
  return sessionStorage.getItem('auth_token');
};

// Set the auth token in localStorage
export const setAuthToken = (token) => {
  sessionStorage.setItem('auth_token', token);
};

// Remove the auth token from localStorage
export const removeAuthToken = () => {
  sessionStorage.removeItem('auth_token');
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!getAuthToken();
};
